import { api } from "../api";

export const passkeyApi = {
    listCredentials: async () => {
        const { data } = await api.get("/webauthn/credentials");
        return data;
    },

    deleteCredential: async (credentialId: string) => {
        const { data } = await api.delete(
            `/webauthn/credentials/${credentialId}`,
        );
        return data;
    },

    renameCredential: async (credentialId: string, friendlyName: string) => {
        const { data } = await api.patch(
            `/webauthn/credentials/${credentialId}`,
            { friendly_name: friendlyName },
        );
        return data;
    },
};
